import React, { useState } from 'react'

export const CreateFolderForm = ({ onCreateFolder, onCancel }) => {
  const [folderName, setFolderName] = useState('')
  const [folderFileCount, setFolderFileCount] = useState('')
  const [error, setError] = useState('')
  const [numError, setNumError] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!folderName.trim()) {
      setError('Folder name is required')
      return
    }

    if (folderName.length > 50) {
      setError('Folder name must be less than 50 characters')
      return
    }

    if (!folderFileCount) {
      setNumError('Total number of file is required')
      return
    }
    onCreateFolder(folderName.trim(), folderFileCount)

    // if (folderName.length > 50) {
    //   setError('Total number of file is required')
    //   return
    // }
  }

  const handleInputChange = (e) => {
    setFolderName(e.target.value)
    if (error) setError('')
  }

  const handleNumInputChange = (e) => {
    setFolderFileCount(e.target.value)
    if (numError) setNumError('')
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-bold text-black mb-4">Create New Folder</h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Folder Name *
            </label>
            <input
              type="text"
              value={folderName}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3d6be0] focus:border-transparent"
              placeholder="Enter folder name"
              maxLength={50}
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Number of Files *
            </label>
            <input
              type="number"
              value={folderFileCount}
              onChange={handleNumInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3d6be0] focus:border-transparent"
              placeholder="Enter required number of file"
              maxLength={50}
            />
            {numError && (
              <p className="text-red-500 text-sm mt-1">{numError}</p>
            )}
          </div>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
            >
              Create Folder
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
